import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { Translate } from '@hydra/common/components';
import ButtonLockedCTA from '@hydra/common/components/CTA/ButtonLockedCTA';
import { useI18n } from '@hydra/common/customHooks';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(4, 0)
  },
  border: {
    borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
    '&:last-of-type': {
      borderBottom: 0
    }
  },
  label: {
    fontWeight: theme.typography.fontWeightSemibold,
    display: 'inline-flex',
    marginRight: theme.spacing(2)
  },
  help: {
    width: '70%',
    marginBottom: theme.spacing(1)
  },
  locked: {
    color: theme.palette.grey[400]
  }
}));

export const EditorFormRow = ({
  children,
  label,
  help,
  infoLabel = false,
  noBorder = false,
  locked = false,
  hasLockedButton = false
}) => {
  const classes = useStyles();
  const { locale } = useI18n();

  const gridClassName = classnames(
    classes.root,
    !noBorder && classes.border,
    locked && classes.locked
  );
  return (
    <Grid
      container
      className={gridClassName}
    >
      {infoLabel
        ? <Grid item>{children}</Grid>
        : (
          <>
            <Grid
              item
              md={4}
              sm={12}
            >
              <Typography className={classes.label}>{label}</Typography>
              {hasLockedButton && (
                <ButtonLockedCTA
                  href={`/${locale}/user/plan`}
                  size='md'
                  hasTooltip
                  tooltipTitle={<Translate content='pdf_editor_upgrade_locked_button_text' />}
                />
              )}
            </Grid>
            <Grid
              item
              container
              md={8}
              sm={12}
            >
              {help && <div className={classes.help}>{help}</div>}
              {children}
            </Grid>
          </>
          )}
    </Grid>
  );
};

EditorFormRow.propTypes = {
  label: PropTypes.node,
  help: PropTypes.node
};

export default EditorFormRow;
